import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../api.service';

@Component({
    selector: 'app-registration-success',
    templateUrl: './registration-success.component.html',
    styleUrls: ['./registration-success.component.scss']
})
export class RegistrationSuccessComponent implements OnInit {
    email = '';
    project = 'hklsc_pthyxs';
    constructor(private route: ActivatedRoute, private router: Router, public api: ApiService) { }

    ngOnInit(): void {
        this.project = this.api.project;
        this.route.queryParams.subscribe(params => {
            this.email = params['email'] || '';
            if (!this.email) {
                this.router.navigate(['/']);
            }
        });
    }
}
